// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"114":"a35673a3","638":"6d3f9d8c","678":"db764cb5","692":"45a74624","711":"42aab565","881":"56e6845d"}[chunkId] + ".chunk.css";
};